import { createMessage } from 'works/legacy/lib/message-helper';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export const createWorksProfileAction = function (form, closeDrawer) {
  return {
    onCompleted(response) {
      if (response && response.createWorksProfile.errors) {
        addErrorsToForm(form, response.createWorksProfile.errors);

        createMessage(
          'error',
          'Failed to create profile due to invalid data. Please try again or contact your hiring partner.'
        );
      } else {
        createMessage('success', 'Candidate has been updated.');
        closeDrawer();
      }
    },
    onError: () => {
      createMessage(
        'error',
        'Failed to create Nurse Profile Details. Please try again or contact your hiring partner.'
      );
    },
    refetchQueries: [
      'PaginatedCandidatesQuery',
      'SupplierJobPageCollectionQuery',
    ],
  };
};

export const updateWorksProfileAction = function (form, closeDrawer) {
  return {
    onCompleted(response) {
      if (response && response.updateWorksProfile.errors) {
        createMessage(
          'error',
          'Failed to update Nurse Profile Details. Please try again or contact your hiring partner.'
        );
        addErrorsToForm(form, response.updateWorksProfile.errors);
      } else {
        createMessage('success', 'Candidate has been updated.');
        closeDrawer();
      }
    },
    onError: () => {
      createMessage(
        'error',
        'Failed to update Nurse Profile Details. Please try again or contact your hiring partner.'
      );
    },
    refetchQueries: [
      'supplierCandidateProfile',
      'supplierDetailedCandidateProfile',
    ],
  };
};
